import { ArrowRight } from "lucide-react";
import { SITUAZIONE_CARDS } from "@/config/site";
import { scrollToHash } from "@/lib/prefill";

export const Situazione = () => (
  <section className="bg-warm py-20 lg:py-28" data-testid="situazione-section">
    <div className="container-ph">
      <div className="reveal max-w-xl">
        <span className="gold-line mb-5" />
        <h2 className="h-section">Qual è la tua situazione?</h2>
      </div>
      <div className="mt-12 grid gap-8 lg:grid-cols-2">
        {SITUAZIONE_CARDS.map((c, i) => (
          <article key={c.label} className={`reveal reveal-delay-${i + 1} group bg-white border border-ivory-dark flex flex-col overflow-hidden`} data-testid={`situazione-card-${i + 1}`}>
            <div className="relative h-60 sm:h-72 overflow-hidden">
              <img src={c.image} alt={c.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
            </div>
            <div className="p-7 sm:p-9 flex flex-col flex-1">
              <p className="eyebrow">{c.label}</p>
              <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-forest leading-tight">{c.title}</h3>
              <p className="mt-4 text-ink/75 leading-relaxed flex-1">{c.text}</p>
              <button onClick={() => scrollToHash(c.href)} className="btn-outline mt-7 self-start" data-testid={`situazione-card-${i + 1}-button`}>
                {c.button} <ArrowRight size={16} />
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);
